export default __webpack_public_path__ + "static/media/01_Kom_Feuerwache Darmstadt.2be2e89d.jpg";